import { Component, inject, Input, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { ProfileImageComponent } from 'src/app/components/auth/profile/profile-image/profile-image.component';
import { User } from 'src/app/models/User';
import { UserService } from 'src/app/services/api/user.service';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { blobToBase64 } from 'src/utils/blob-to-base64';

@Component({
  selector: 'app-user-profile-view',
  templateUrl: './user-profile-view.component.html',
  styleUrls: ['./user-profile-view.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, ProfileImageComponent]
})
export class UserProfileViewComponent implements OnInit {
  private userService = inject(UserService);

  @Input({ required: true }) user!: User;

  // undefined represents the initial state of the profile picture
  profilePictureBase64: string | null | undefined = undefined;

  isLoading = false;

  ngOnInit() {
    this.isLoading = true;
    if (this.user.id && this.user.profilePictureId) {
      this.userService
        .getProfilePicture(this.user.id)
        .pipe(first())
        .subscribe((blob) => {
          blobToBase64(blob)
            .pipe(first())
            .subscribe((base64) => {
              this.profilePictureBase64 = base64;
              this.isLoading = false;
            });
        });
    } else {
      this.profilePictureBase64 = null;
      this.isLoading = false;
    }
  }
}
